module.exports = __webpack_public_path__ + "static/media/文档上传演示.a776a912.png";